export default "__VITE_ASSET__8075354e__"